export function InvoiceSVG({ size = 60 }) {
  return (
    <svg width={size} height={size}  fill="none" aria-hidden>
      <rect x="3" y="4" width="30" height="35" rx="3" stroke="currentColor" strokeWidth="2"/>
      <path d="M7 8h7M7 12h7M7 16h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M19 7v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="19" cy="16.5" r="1.5" fill="currentColor"/>
    </svg>
  );
}
